import { t } from "@lingui/macro";

export function getDefaultText() {
  return `${t`sequenceDiagram`}
    ${t`Consumer->>+API: Book something`}
    ${t`API->>+BookingService: Start booking process`}
    ${t`break when the booking process fails`}
      ${t`API-->>-Consumer: show failure`}
    ${t`end`}
    ${t`API->>+BillingService: Start billing process`}
`;
}
